import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { Location } from '@angular/common';
import { StateService } from '../../services/state.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-header',
  templateUrl: 'app-header.component.html',
  styleUrl: 'app-header.component.scss',
  providers: [provideNativeDateAdapter()],
  imports: [MatCardModule, MatDatepickerModule, FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppHeader {
  constructor(private location: Location) { }

  #stateService = inject(StateService)

  postalCodeUrl = computed(() => {
    const postalCode = this.#stateService.customer()?.postalCode
    return postalCode ? '?postalCode=' + postalCode : ''
  })

  faAngleLeft = faAngleLeft

  isPostalCode = computed(() => this.#stateService.currentUrl() === '/postal-code');

  goBack() {
    this.location.back();
  }

}